import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import classNames from 'classnames'

import styles from './dropdown.css'

import DropdownIcon from '../../../assets/images/dropdown-arrow.svg'

const Dropdown = ({ children, direction, padding, overlay }) => (
  <div
    styleName={
      classNames('dropdown', `dropdown-padding-${padding}`, {
        'dropdown-overlay': overlay,
      })
    }
  >
    {children}
    <DropdownIcon styleName={`triangle-${direction}`} />
  </div>
)

Dropdown.propTypes = {
  children: PropTypes.any,
  direction: PropTypes.oneOf([
    'top',
    'top-right',
    'top-left',
    'right',
    'bottom',
    'bottom-right',
    'bottom-left',
    'left',
  ]),
  overlay: PropTypes.bool,
  padding: PropTypes.oneOf(['none', 'small', 'medium', 'large']),
}

Dropdown.defaultProps = {
  direction: 'bottom',
  overlay: false,
  padding: 'none',
}

export default CSSModules(Dropdown, styles, { allowMultiple: true })



/** WEBPACK FOOTER **
 ** ./src/components/dropdown/dropdown.js
 **/